import type { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { BirthdayComponent } from './BirthdayComponent'
import type { RootState } from 'shared/store/reducers'
import {
    fetchBirthdayPageData,
    resetBirthday,
    resetError,
    sendBirthdayForm,
    fetchOpeningHours
} from 'shared/store/birthday'
import { fetchProfilePageData } from 'shared/store/kingdom/profile'
import type { FormBirthdayBooking } from 'shared/types'
import { push } from 'connected-react-router'

const mapStateToProps = (state: RootState) => {
    const { birthdayPageState, kingdomProfilePageState } = state
    const { authenticated } = state.userState
    return {
        ...birthdayPageState,
        ...kingdomProfilePageState,
        authenticated
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchPageData: () => d(fetchBirthdayPageData()),
    sendForm: (form: FormBirthdayBooking) => d(sendBirthdayForm(form)),
    resetError: () => d(resetError()),
    reset: () => d(resetBirthday()),
    fetchOpeningHours: (restaurantId: string) =>
        d(fetchOpeningHours(restaurantId)),
    navigate: (to: string, state?: any) => d(push({ pathname: to, state })),
    fetchProfileData: () => d(fetchProfilePageData())
    // sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
})

const Birthday = connect(mapStateToProps, mapDispatchToProps)(BirthdayComponent)

export { Birthday }
